import html from "./ActionGroup.html"
import "./ActionGroup.css"

var module = angular.module("ResearchKitApplicationModule");
module.component('actionGroupDashboardComponent', {
	template: html,
	bindings: {
		"model": "<"
	},
	controller: 'actionGroupController',
	controllerAs: 'vm'
});

module.controller("actionGroupController", ["$scope", "ceUrl",
	function ($scope, ceUrl) {
		var vm = this;

		vm.performAction = function (action) {
			var actionPayload = { type: action.Action };
			$scope.$emit("performAction", actionPayload);
		}
	}
]);
